<template>
  <section class="sharkbet-income-history" :class="`sharkbet-income-history--${variant}`">
    <h2>HISTORIAL DE INGRESOS</h2>
    <label class="sharkbet-income-history__search">Filtrar resultados
      <span><i class="fas fa-search" aria-hidden="true"></i><input v-model.trim="search" type="search" aria-label="Filtrar historial de ingresos"></span>
    </label>
    <div class="sharkbet-income-history__table-wrap">
      <div v-if="loading" class="sharkbet-income-history__loading"><div class="spinner-border" role="status"></div></div>
      <table v-else class="sharkbet-income-history__table">
        <thead><tr><th>Fecha</th><th>Acción</th><th>IP</th><th>Dispositivo</th></tr></thead>
        <tbody>
          <tr v-for="(item, index) in visibleRecords" :key="index">
            <td>{{ formatDate(item.fecha) }}</td><td>{{ item.descripcion }}</td><td>{{ item.ip }}</td><td><i :class="item.plataforma === 'desktop' ? 'fas fa-desktop' : 'fas fa-mobile-alt'"></i></td>
          </tr>
          <tr v-if="filteredRecords.length === 0"><td colspan="4">No hay registros</td></tr>
        </tbody>
      </table>
    </div>
    <div class="sharkbet-income-history__footer">
      <span>{{ filteredRecords.length }} Registros</span>
      <button v-if="visibleRecords.length < filteredRecords.length" type="button" @click="visibleCount += 12">Mostrar mas</button>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SharkbetIncomeHistory',
  props: {
    autoLoad: { type: Boolean, default: false },
    variant: { type: String, default: 'desktop' },
  },
  data() {
    return { loading: false, records: [], search: '', visibleCount: 12 };
  },
  computed: {
    apiUrl() { return this.$store.getters['getApiUrlnew']; },
    user() { return this.$store.getters['getUserData']; },
    filteredRecords() {
      const search = this.search.toLowerCase();
      if (!search) return this.records;
      return this.records.filter((item) => Object.values(item).join(' ').toLowerCase().includes(search));
    },
    visibleRecords() { return this.filteredRecords.slice(0, this.visibleCount); },
  },
  methods: {
    async fetchHistory() {
      if (!this.user.token || this.loading) return;

      this.loading = true;
      this.visibleCount = 12;
      try {
        const response = await axios.get(`${this.apiUrl}user/auditoria`, {
          headers: { 'x-api-key': 'FTBBW4bR1pKTUFsURbFD8RpcPygh8wN6', 'x-player-token': this.user.token },
        });
        this.records = Array.isArray(response.data) ? response.data : response.data?.data || [];
      } catch {
        this.records = [];
      } finally {
        this.loading = false;
      }
    },
    formatDate(value) {
      const date = new Date(value);
      const pad = (number) => String(number).padStart(2, '0');
      return `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
  },
  mounted() {
    if (this.autoLoad) this.fetchHistory();
    this.$root.$on('getIngresosHistory', this.fetchHistory);
  },
  beforeDestroy() {
    this.$root.$off('getIngresosHistory', this.fetchHistory);
  },
};
</script>

<style scoped>
.sharkbet-income-history h2 { color: #17212a; font: 400 30px 'Roboto', sans-serif; margin: 0 0 26px; }

.sharkbet-income-history__search {
  align-items: center;
  background: #f6f6f6;
  color: #17212a;
  display: flex;
  font: 500 16px 'Roboto', sans-serif;
  gap: 10px;
  padding: 20px 24px;
}

.sharkbet-income-history__search span {
  align-items: center;
  background: #fff;
  border: 1px solid #c8c8c8;
  border-radius: 22px;
  display: flex;
  height: 40px;
  padding: 0 12px;
  width: 230px;
}

.sharkbet-income-history__search i { color: #777; }
.sharkbet-income-history__search input { background: transparent; border: 0; color: #17212a; font: 14px 'Roboto', sans-serif; min-width: 0; outline: 0; padding: 0 8px; width: 100%; }

.sharkbet-income-history__table-wrap { background: #f6f6f6; overflow-x: auto; padding: 0 24px; }

.sharkbet-income-history__table {
  border-collapse: separate;
  border-spacing: 0;
  color: #7a8790;
  font: 13px 'Roboto', sans-serif;
  min-width: 620px;
  width: 100%;
}

.sharkbet-income-history__table th { background: #0089b8; border-right: 1px solid #52606a; color: #fff; font-weight: 600; padding: 14px 8px; text-align: center; }
.sharkbet-income-history__table th:first-child { border-radius: 16px 0 0 0; }
.sharkbet-income-history__table th:last-child { border-radius: 0 16px 0 0; border-right: 0; }
.sharkbet-income-history__table td { background: #fafafa; border-right: 1px solid #52606a; border-top: 1px solid #52606a; padding: 12px 8px; text-align: center; }
.sharkbet-income-history__table td:last-child { border-right: 0; }
.sharkbet-income-history__table tbody tr:nth-child(even) td { background: #f0f0f0; }
.sharkbet-income-history__table tbody tr:last-child td:first-child { border-radius: 0 0 0 16px; }
.sharkbet-income-history__table tbody tr:last-child td:last-child { border-radius: 0 0 16px 0; }
.sharkbet-income-history__table td[colspan] { border-radius: 0 0 16px 16px; padding: 24px; }
.sharkbet-income-history__loading { background: #f6f6f6; color: #008ccd; padding: 34px; text-align: center; }

.sharkbet-income-history__footer { background: #f6f6f6; display: grid; gap: 10px; padding: 18px 24px 24px; }
.sharkbet-income-history__footer span { color: #7a8790; font: 12px 'Roboto', sans-serif; }
.sharkbet-income-history__footer button { background: #0092cd; border: 0; border-radius: 18px; color: #fff; cursor: pointer; font: 600 12px 'Roboto', sans-serif; height: 29px; justify-self: start; padding: 0 14px; }

@media (max-width: 767px) {
  .sharkbet-income-history__search { align-items: flex-start; flex-direction: column; padding: 16px; }
  .sharkbet-income-history__search span { width: 100%; }
  .sharkbet-income-history__table-wrap { padding: 0 16px; }
  .sharkbet-income-history__footer { padding: 16px; }
}
</style>
